import { useState } from "react";
import { toast } from "sonner";
import { Settings as SettingsIcon, LogOut, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";
import { readToken, clearToken } from "@/lib/tokenStore";

const BANNER_KEY = "pine_journey_banner_dismissed";

export default function Settings() {
  const navigate = useNavigate();
  const [resetting, setResetting] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const onResetBanner = () => {
    setResetting(true);
    try {
      localStorage.removeItem(BANNER_KEY);
      toast.success("Banner für /admin/leads wieder eingeblendet.");
    } catch {
      toast.error("LocalStorage ist nicht verfügbar.");
    } finally {
      setResetting(false);
    }
  };

  const onLogout = async () => {
    setLoggingOut(true);
    const token = readToken();
    try {
      if (token) {
        await axios.post(`${API}/admin/logout`, null, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {
      /* ignore */
    }
    clearToken();
    toast.success("Abgemeldet");
    navigate("/admin", { replace: true });
  };

  return (
    <div className="mx-auto max-w-2xl space-y-8">
      <div className="flex items-center gap-3">
        <div className="inline-flex h-9 w-9 items-center justify-center rounded border border-white/10 text-emerald-400/80">
          <SettingsIcon className="h-4 w-4" />
        </div>
        <div>
          <h1 className="text-lg font-semibold text-zinc-100">Einstellungen</h1>
          <p className="text-xs uppercase tracking-[0.18em] text-emerald-400/70">
            Vorerst minimal — echte CRM-Einstellungen folgen
          </p>
        </div>
      </div>

      <section
        data-testid="journey-settings-actions"
        className="space-y-3 rounded-md border border-white/10 bg-white/[0.02] p-5"
      >
        <h2 className="text-sm font-medium text-zinc-200">Aktionen</h2>
        <p className="text-sm text-muted-foreground">
          Schnelle Verwaltung deiner Sitzung und der UI-Hinweise.
        </p>
        <div className="flex flex-col gap-3 pt-2 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            onClick={onResetBanner}
            disabled={resetting}
            data-testid="journey-settings-reset-banner"
            className="border-white/10 bg-transparent text-zinc-200 hover:bg-white/[0.04]"
          >
            <RotateCcw className="mr-2 h-4 w-4" />
            Legacy-Leads-Banner zurücksetzen
          </Button>
          <Button
            type="button"
            onClick={onLogout}
            disabled={loggingOut}
            data-testid="journey-settings-logout"
            className="bg-emerald-500 text-zinc-950 hover:bg-emerald-400"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Abmelden
          </Button>
        </div>
      </section>

      <p className="text-xs text-zinc-500">
        Weitere Einstellungen — Pipelines, Tags, Benutzer, Benachrichtigungen —
        werden in späteren Batches ergänzt.
      </p>
    </div>
  );
}
